"use strict";

exports.__esModule = true;
exports["default"] = SocialInstagramInverted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialInstagramInverted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M404.5 91h-297C98.376 91 91 98.376 91 107.5v297c0 9.124 7.376 16.5 16.5 16.5h297c9.124 0 16.5-7.376 16.5-16.5v-297c0-9.124-7.376-16.5-16.5-16.5zM255.741 192.329c35.006 0 63.347 28.341 63.347 63.347s-28.406 63.347-63.347 63.347c-35.006 0-63.347-28.406-63.347-63.347-.065-34.941 28.341-63.347 63.347-63.347zm126.694 177.424c0 6.988-5.694 12.682-12.682 12.682H141.665c-6.988 0-12.682-5.694-12.682-12.682V230.376h28.665c-2.071 8.088-3.3 16.565-3.3 25.365 0 55.971 45.359 101.394 101.329 101.394s101.394-45.359 101.394-101.394c0-8.735-1.229-17.212-3.3-25.365h28.665v139.377zm0-190.041c0 6.988-5.694 12.682-12.682 12.682h-37.982c-6.988 0-12.682-5.694-12.682-12.682v-38.047c0-6.988 5.629-12.682 12.682-12.682h37.982c6.988 0 12.682 5.694 12.682 12.682v38.047z",
    fill: "#939496"
  }));
}